/**
 * True when a file preview overlay is open (doc upload viewer or
 * mission attachments preview). Host Esc handlers (doc sheet, mission
 * nav, etc.) should defer so Esc closes only the viewer.
 */
export const isAttachmentPreviewOpen = () =>
  !!document.querySelector('.file-upload-preview, .preview-panel');
